import { render, staticRenderFns } from "./ColorPage.vue?vue&type=template&id=556664ca&scoped=true&"
import script from "./ColorPage.vue?vue&type=script&lang=js&"
export * from "./ColorPage.vue?vue&type=script&lang=js&"
import style0 from "./ColorPage.vue?vue&type=style&index=0&id=556664ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556664ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VImg,VProgressCircular,VRow})
